import {
  BreakpointsEnum,
  ButtonType,
  CaesarsButton,
  isBreakpointUp,
  useBreakpoint,
  useIsDesktop,
  useIsSM,
  useIsXS,
} from '@eCommerce/frontend-legacy-shared-library-native';
import {Box, Text, View} from 'native-base';
import React from 'react';

import {REFRESH_BANNER_HEADING} from 'models/Offer';

interface RefreshBannerProps {
  onRefreshOffersPress: () => void;
  onDismissPress: () => void;
}

const RefreshBanner: React.FC<RefreshBannerProps> = ({
  onDismissPress,
  onRefreshOffersPress,
}) => {
  const breakpoint = useBreakpoint();
  const isMicro = isBreakpointUp(breakpoint, BreakpointsEnum.MICRO);
  const isXS = useIsXS();
  const isSM = useIsSM();
  const isDesktop = useIsDesktop();

  return (
    <Box
      mb={isDesktop ? '24px' : '16px'}
      p="16px"
      alignItems="center"
      bgColor="white"
      w="100%"
      flexDirection={isSM ? 'row' : 'column'}
      justifyContent={isXS ? 'space-between' : undefined}
      borderRadius={4}
      shadow={0}>
      <View mb={isSM ? undefined : '8px'}>
        <Text lineHeight="20px" fontWeight="bold">
          {REFRESH_BANNER_HEADING}
        </Text>
      </View>
      <View
        w={isSM ? undefined : '100%'}
        flexDirection={isMicro ? 'row' : 'column-reverse'}
        justifyContent={isSM ? 'flex-end' : 'center'}>
        <View flex={1}>
          <CaesarsButton
            type={ButtonType.TEXT_CTA}
            title="Dismiss"
            onPress={onDismissPress}
            isFullWidth={true}
          />
        </View>
        <View
          width={isMicro ? 2 : undefined}
          height={isMicro ? undefined : 2}
        />
        <View flex={1}>
          <CaesarsButton
            title="Refresh Offers"
            onPress={onRefreshOffersPress}
            isFullWidth={true}
          />
        </View>
      </View>
    </Box>
  );
};

export default RefreshBanner;
